import { motion } from 'framer-motion';
import { createPortal } from 'react-dom';
import '../App.css';

const ConfirmSwapModal = ({
  isOpen,
  onClose,
  onConfirm,
  fromToken,
  toToken,
  fromAmount,
  toAmount,
  slippageBps,
  slippageMode,
  minReceived
}) => {
  return createPortal(
    <motion.div
      className="lr-modal"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25, ease: "easeInOut" }}
      onClick={onClose}
    >
      <motion.div 
        className="lr-modal-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.25 }}
      />
      <motion.div
        className="lr-modal-content"
        onClick={(e) => e.stopPropagation()}
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: 20 }}
        transition={{ 
          duration: 0.25, 
          ease: [0.4, 0, 0.2, 1]
        }}
      >
            <div className="lr-modal-header">
              <h3>Confirm Swap</h3>
            </div>

            <div className="lr-modal-body">
              <div className="confirm-row">
                <span>From</span>
                <span>
                  {fromAmount} {fromToken?.symbol}
                </span>
              </div>

              <div className="confirm-row">
                <span>To</span>
                <span>
                  {toAmount} {toToken?.symbol}
                </span>
              </div>

              <div className="confirm-row">
                <span>Minimum received</span>
                <span>
                  {minReceived} {toToken?.symbol}
                </span>
              </div>

              <div className="confirm-row">
                <span>Slippage</span>
                <span>{slippageMode === 'auto' ? 'Auto' : `${(slippageBps / 100).toFixed(2)}%`}</span>
              </div>

              <div className="confirm-row">
                <span>Router</span>
                <span>PancakeSwap V2</span>
              </div>

              <div className="confirm-actions">
                <button className="lr-btn" onClick={onClose} data-press>
                  Cancel
                </button>
                <button className="lr-btn lr-btn-primary" onClick={onConfirm} data-press>
                  Confirm Swap
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>,
        document.body
      );
};

export default ConfirmSwapModal;
